module.exports = __webpack_public_path__ + "img/lighthouse-rafiki.da55a7c2.svg";